import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagesReportCoreRoutingModule } from './pages-report-core-routing.module';
import { PageSelectionReportComponent } from './page-selection-report/page-selection-report.component';
import { ReportSelectionModule } from '../../components/report-selection/report-selection.module';


@NgModule({
  declarations: [
    PageSelectionReportComponent
  ],
  imports: [
    CommonModule,
    PagesReportCoreRoutingModule,
    ReportSelectionModule
  ]
})
export class PagesReportCoreModule { }
